export const BankAccountTypes = [
    {
        id: 0,
        name: 'Checking'
    },
    {
        id: 1,
        name: 'Savings'
    }
];
